<template>
  <div class="container1 side-gap" :class='$layout.isMobile ? "mobile" : undefined'>
    <div class="items space-between" :class='$layout.isMobile ? "flex-column" : "flex-row"'>
      <template v-for="item in items">
        <FeatureTile :key="item.title" :icon="item.icon" :title="item.title" :text="item.text"/>
      </template>
    </div>
  </div>
</template>

<script>
import FeatureTile from "@/components/FeatureTile";
export default {
  name: 'WelcomeFeatures',
  components: {
    FeatureTile,
  },
  data() {
    return {
      items: [
        {
          icon: "heart",
          title: "Поддержка и консультация",
          text: "Технические консультации по работе оборудования",
        },
        {
          icon: "gear",
          title: "Помощь в установке",
          text: "Наши специалисты помогут  в установке и настройке ПО",
        },
        {
          icon: "case",
          title: "Юридическая прозрачность",
          text: "Работа по договору: оформление актов и чеков",
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>

.container1.mobile {
  margin-top: 120px;
  margin-bottom: 120px;
}

.container1 {
  margin-top: 200px;
  margin-bottom: 200px;
  justify-content: center;

  .items {
    gap: 50px;
  }
}

</style>
